/*!
 * AudoChat - App Routes Component
 */

import { Route } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoute";
import auth from "utils/auth";
import { PERMISSIONS } from "utils/database";

const getRoutes = (allRoutes) => {
  if (!allRoutes || !Array.isArray(allRoutes)) {
    return null;
  }
  
  return allRoutes.map((route) => {
    if (route.collapse) {
      return getRoutes(route.collapse);
    }

    if (route.route) {
      // Map routes to permissions
      const routePermissions = {
        "/dashboard": PERMISSIONS.DASHBOARD,
        "/chat": PERMISSIONS.CHAT,
        "/chat-bate": PERMISSIONS.CHAT,
        "/tables": PERMISSIONS.CRM,
        "/items": PERMISSIONS.ITEMS,
        "/billing": PERMISSIONS.BILLING,
        "/settings": PERMISSIONS.SETTINGS,
        "/ai": PERMISSIONS.SETTINGS, // Use SETTINGS permission for AI
      };

      const permission = routePermissions[route.route];
      
      // Public routes (sign-in only)
      if (route.route.includes("/authentication/sign-in")) {
        return <Route exact path={route.route} component={route.component} key={route.key} />;
      }

      // Protected routes
      if (permission) {
        return (
          <ProtectedRoute
            exact
            path={route.route}
            component={route.component}
            permission={permission}
            key={route.key}
          />
        );
      }

      // Other routes (profile, etc.)
      return (
        <ProtectedRoute
          exact
          path={route.route}
          component={route.component}
          key={route.key}
        />
      );
    }

    return null;
  });
};

export default getRoutes;

